module.exports = __webpack_public_path__ + "media/images/common/project_active-a513ae81c223d358b57adf002ec0ace1.png";